import { render, staticRenderFns } from "./SaleOrderList.vue?vue&type=template&id=5dd0212a&scoped=true"
import script from "./SaleOrderList.vue?vue&type=script&lang=js"
export * from "./SaleOrderList.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderList.vue?vue&type=style&index=0&id=5dd0212a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0212a",
  null
  
)

export default component.exports